import { Controller } from "@hotwired/stimulus"
import { Tooltip } from 'bootstrap'

// Connects to data-controller="tooltip"
export default class extends Controller {
  static values = { options: { type: Object, default: { placement: "bottom" }}}
  connect() {
    new Tooltip(this.element, this.optionsValue)
  }
}
